import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type VideoShotSliceState = {
  videos: Record<string, any>;
};

const initialState: VideoShotSliceState = {
  videos: {}
};

const VideoShotSlice = createSlice({
  name: 'videoshots',
  initialState: initialState,
  reducers: {
    addVideoShot: (state, action: PayloadAction<{ videoHashId: string; videoData: any }>) => {
      const { videoHashId, videoData } = action.payload;
      state.videos[videoHashId] = videoData; // Add video to the videos object using videoId as the key
    }
  }
});

export const { addVideoShot } = VideoShotSlice.actions;
export const VideoShotsReducers = VideoShotSlice.reducer;
